import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'front-onceforall-core';
import { useHistory } from 'react-router-dom';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function LinkButtonView(props) {
  const history = useHistory();
  return /*#__PURE__*/_jsxs("button", {
    type: "button",
    className: "large secondary flex-container mt-3",
    onClick: () => history.push(props.link),
    children: [props.buttonLabel, /*#__PURE__*/_jsx(Icon, {
      icon: "arrow-right"
    })]
  });
}
LinkButtonView.propTypes = {
  link: PropTypes.string.isRequired,
  buttonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};
export default LinkButtonView;